const YUP_PASSWORD_MATCH_REGEX =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[\^$*.[\]{}()?\-"!@#%&/\\,><':;|_~`+=])\S{8,99}$/;
const YUP_PASSWORD_MATCH_MESSAGE =
  'Must contain at least 8 characters, one uppercase, one lowercase, one number, and one special character (^ $ * . [ ] { } ( ) ? - " ! @ # % & / \\ , > < \' : ; | _ ~ ` + =)';

export { YUP_PASSWORD_MATCH_REGEX, YUP_PASSWORD_MATCH_MESSAGE };
